module.exports = __webpack_public_path__ + "img/grade.5d594cfb.jpg";